export default "__VITE_ASSET__DPdyCcyu__"